VjsAdmin.IpWhitelist = (function () {
    const $table = $('#ip-whitelist-table');
    const apiUrl = '/api/ip-whitelist/';

    const init = function () {
        initWhitelistTable();
        const main = new Main();
        main.changePlatform();
    };

    const Main = VjsUtility.Controller.extend({
        events: {
            'click .remove-ip': 'removeIP',
            'change #platform_id': 'changePlatform',
        },
        removeIP(e) {
            const $el = $(e.currentTarget);
            const whitelistId = $el.data('id');

            if (!window.confirm('Are you sure you want to remove this IP?')) {
                return;
            }

            $el.parent().html('deleting...');

            const req = new VjsUtility.Request();
            req.delete(`${apiUrl + $('#platform_id').val()}/${whitelistId}`)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'Successfully removed IP!',
                        time: 4000,
                    });
                })
                .fail(() => {
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                })
                .always(() => {
                    $table.bootstrapTable('refresh');
                });
        },
        changePlatform() {
            let params = {};
            params.platform_id = $('#platform_id').val();
            if (params.platform_id === '') {
                params = {};
            }
            $table.bootstrapTable('refresh', {
                url: `${apiUrl}?${new URLSearchParams(params).toString()}`,
            });
        },
    });

    const initWhitelistTable = function () {
        const params = {};
        params.platform_id = $('#platform_id').val();
        $table.bootstrapTable({
            ...VjsTable.simpleTableDefaults(),
            table: '#ip-whitelist-table',
            method: 'get',
            formatNoMatches() {
                return 'None found';
            },
            idField: 'id',
            showRefresh: true,
            showColumns: true,
            pagination: true,
            sidePagination: 'server',
            search: true,
            pageList: [25, 50],
            pageSize: 25,
            toolbar: '#table-toolbar',
            toolbarAlign: 'right',
            icons: {
                refresh: 'fa-refresh',
            },
            sortName: 'created_at',
            sortOrder: 'desc',
            columns: [
                {
                    title: 'IP',
                    field: 'ip_address',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    searchable: true,
                },
                {
                    title: 'District ID',
                    field: 'district_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    searchable: true,
                },
                {
                    title: 'License ID',
                    field: 'license_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    searchable: true,
                },
                {
                    title: 'Role ID',
                    field: 'role_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    searchable: true,
                },
                {
                    title: 'Created At',
                    field: 'created_at',
                    align: 'center',
                    valign: 'middle',
                    visible: true,
                    searchable: false,
                    sortable: true,
                },
                {
                    title: 'Actions',
                    field: 'action',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                    formatter(value, row) {
                        return `<a href='javascript:void(0);' class='remove-ip text-success' data-id='${row.id}' title="Remove IP"><i class='fa fa fa-times text-danger' aria-hidden='true'></i></a>`;
                    },
                },
            ],
            responseHandler(res) {
                return {
                    total: res.meta.total ? res.meta.total : 0,
                    rows: res.data,
                };
            },
        });
    };

    return {
        init,
    };
}());
